import { render, staticRenderFns } from "./BuilderMatchMedia.vue?vue&type=template&id=44a71e10"
import script from "./BuilderMatchMedia.vue?vue&type=script&lang=ts"
export * from "./BuilderMatchMedia.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports